import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../../../constants/general-constants";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default function UtilisationChartBarSmall({}){
	
	const chartId = "utilisationchartbarsmall";
	
	const chartData = [
		{label:'Mon 09:00', utilisation:"30", capacity:"20", unused:"110"},
		{label:'Mon 11:00', utilisation:"40", capacity:"22", unused:"98"},
		{label:'Mon 13:00', utilisation:"70", capacity:"45", unused:"45"},
		{label:'Mon 14:00', utilisation:"70", capacity:"60", unused:"30"},
		{label:'Mon 17:00', utilisation:"60", capacity:"60", unused:"40"},
		{label:'Tue 09:00', utilisation:"30", capacity:"20", unused:"110"},
		{label:'Tue 11:00', utilisation:"40", capacity:"12", unused:"108"},
		{label:'Tue 13:00', utilisation:"70", capacity:"45", unused:"45"},
		{label:'Tue 14:00', utilisation:"70", capacity:"60", unused:"30"},
		{label:'Tue 17:00', utilisation:"60", capacity:"60", unused:"40"},
		{label:'Wed 09:00', utilisation:"30", capacity:"20", unused:"110"},
		{label:'Wed 11:00', utilisation:"40", capacity:"22", unused:"98"},
		{label:'Wed 13:00', utilisation:"70", capacity:"45", unused:"45"},
		{label:'Wed 14:00', utilisation:"70", capacity:"60", unused:"30"},
		{label:'Wed 17:00', utilisation:"60", capacity:"90", unused:"10"},
		{label:'Thu 09:00', utilisation:"30", capacity:"20", unused:"110"},
		{label:'Thu 11:00', utilisation:"40", capacity:"22", unused:"98"},
		{label:'Thu 13:00', utilisation:"70", capacity:"45", unused:"45"},
		{label:'Thu 14:00', utilisation:"70", capacity:"60", unused:"30"},
		{label:'Thu 17:00', utilisation:"60", capacity:"60", unused:"40"},
		{label:'Fri 09:00', utilisation:"30", capacity:"20", unused:"110"},
		{label:'Fri 11:00', utilisation:"40", capacity:"22", unused:"98"},
		{label:'Fri 13:00', utilisation:"70", capacity:"45", unused:"45"},
		{label:'Fri 14:00', utilisation:"70", capacity:"60", unused:"30"},
		{label:'Fri 17:00', utilisation:"60", capacity:"60", unused:"40"},
	];
	
	const graphs = [
		{title:"Occupied", keyColumn:"utilisation", color:"darkblue"},
		{title:"Signs Of Life", keyColumn:"capacity", color:"lightblue"},
		{title:"Unused", keyColumn:"unused", color:"#eee"}
	];
	
	useEffect(() => {
		let categoryKey = "label";
		
		let x = am4core.create(chartId, am4charts.XYChart);
		x.fontSize = 10;
    x.fill='black';
    x.strokeAlpha=0;
		x.paddingTop = 0;
		x.paddingRight = 10;
		x.paddingLeft = 0;
		x.paddingBottom = 0;
		let categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.renderer.grid.template.strokeOpacity = 0;
		categoryAxis.renderer.labels.template.strokeOpacity=0;
		categoryAxis.renderer.labels.template.fillOpacity=1;
		categoryAxis.dataFields.category=categoryKey;	
		categoryAxis.renderer.labels.template.rotation=-90;
		categoryAxis.renderer.minGridDistance = 15;
		
		let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
		valueAxis.renderer.grid.template.strokeOpacity = 0;
		valueAxis.renderer.labels.template.strokeOpacity=0;
		valueAxis.renderer.labels.template.fillOpacity=0;
		
		for(let i=0; i<graphs.length; i++){
	 		let series = x.series.push(new am4charts.ColumnSeries());
	 		series.name = graphs[i].title;
	    series.dataFields.categoryX = categoryKey;
	    series.dataFields.valueY = graphs[i].keyColumn;
	    series.fill = graphs[i].color;
	    series.stroke = graphs[i].color;
	    series.tooltipText = graphs[i].title + " ({categoryX}): {valueY}";
  		series.tooltip.label.wrap=true;
  		series.tooltip.label.width=300;
  		series.tooltip.label.fill='black';
  		series.stacked=true;
	  }
	   
	   x.cursor = new am4charts.XYCursor();
	   
			x.data = chartData;
			chart.current = x;
	}, [chartData, graphs]);
	
	const chart = useRef(null);
	
	
	
	const thisContainer = {
		display:'flex',
		width:"calc(100% - 400px)",
		height:"100%",
		fontWeight:"bold",
		flexDirection:"column"
	};
	
	const chartContainer ={ 
		display:"flex",
		width:"100%",
		height:"calc(100% - 0px)",
		marginTop:"-10px"
	};
	
	return (
		<div style={thisContainer}>
			<div style={chartContainer} id={chartId}>
			
			</div>
			
		</div>
	);
}